<script>
import { formTreeSelectConfig } from "@/components/base/conf";
import popupTreeSelect from "@/components/base/popup/popupTreeSelect";

export default {
  name: "formMultiple",
  components: {
    popupTreeSelect
  },
  props: {
    //标题
    title: {
      type: String,
      default: ""
    },
    //引导词
    placeholder: {
      type: String,
      default: "请选择"
    },
    //是否开启多选
    multiple: {
      type: Boolean,
      default: false
    },
    //是否开启搜索
    search: {
      type: Boolean,
      default: false
    },
    //搜索框 过滤值
    searchFilter: {
      type: [String, Array, Function],
      default: () => formTreeSelectConfig.searchFilter
    },
    //搜索框 提示
    searchPlaceholder: {
      type: String,
      default: ""
    },
    //值
    value: {
      type: [Array, String, Number],
      default: ""
    },
    //下拉数据
    options: {
      type: Array,
      default: () => []
    },
    //id 参数
    valueField: {
      type: String,
      default: formTreeSelectConfig.valueField
    },
    //文字参数
    labelField: {
      type: String,
      default: formTreeSelectConfig.labelField
    },
    //子级参数
    childrenField: {
      type: String,
      default: formTreeSelectConfig.childrenField
    },
    //禁用field
    disabledField: {
      type: String,
      default: formTreeSelectConfig.disabledField
    },
    //是否带有确认框
    isConfirm: {
      type: Boolean,
      default: true
    },
    //确认文字描述
    confirmButtonText: {
      type: String,
      default: "确认"
    },
    //取消文字描述
    cancelButtonText: {
      type: String,
      default: "取消"
    },
    //最大数量
    max: {
      type: [String, Number],
      default: Infinity
    },
    //弹窗高度
    height: {
      type: String,
      default: "60vh"
    },
    //点击遮罩层是否关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    },
    //是否必填
    required: {
      type: Boolean,
      default: false
    },
    //禁用
    disabled: {
      type: Boolean,
      default: false
    },
    //多选时  显示文字样式类型
    fieldButtonType: {
      type: String,
      default: "primary"
    }
  },
  data() {
    return {
      realValue: null,
      visible: false
    };
  },
  watch: {
    realValue(e) {
      if (this.realValue != this.value) {
        this.$emit("input", e);
      }
    },
    value(e) {
      if (this.realValue != this.value) {
        this.realValue = e;
      }
    }
  },
  created() {
    this.realValue = this.value || (this.multiple ? [] : "");
  },
  methods: {
    /**
     * @description: 获取值
     * @param {*}
     * @return {*}
     */
    getValue() {
      return this.realValue;
    },
    /**
     * @description: 赋值
     * @param {*}
     * @return {*}
     */
    setValue(e) {
      this.realValue = e;
    },
    /**
     * @description: 显示弹窗
     * @param {*}
     * @return {*}
     */
    popupShow() {
      let { readonly, disabled } = this;
      if (!(readonly || disabled)) {
        this.visible = true;
      }
    },
    /**
     * @description: 确认
     * @param {*} e
     * @param {*} rows
     * @return {*}
     */
    confirm(e, rows) {
      this.realValue = e;
      this.$emit("change", e, rows);
    },
    /**
     * @description: 输入框 渲染
     * @param {*}
     * @return {*}
     */
    fieldRender() {
      let { readonly, disabled } = this;
      let btns = this.buttonRender();
      let arrow;
      readonly = readonly || disabled;
      if (!readonly) {
        arrow = <i class="van-icon van-icon-arrow" />;
      }
      return (
        <div class="van-cell van-field" onClick={this.popupShow}>
          <div class="van-cell__title van-field__label">
            <span>{this.title}</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body">
              {btns}
              <div class="van-field__right-icon">{arrow}</div>
            </div>
          </div>
        </div>
      );
    },
    /**
     * @description: 选中项 渲染
     * @param {*}
     * @return {*}
     */
    buttonRender() {
      let {
        realValue,
        valueField,
        labelField,
        childrenField,
        fieldButtonType,
        options
      } = this;
      let content;
      if (realValue) {
        if (!this.multiple) {
          for (let i = 0; i < options.length; i++) {
            let item = options[i];
            for (let j = 0; j < item[childrenField].length; j++) {
              let dItem = item[childrenField][j];
              if (dItem[valueField] == realValue) {
                content = (
                  <input value={dItem[labelField]} class="van-field__control" />
                );
                break;
              }
            }
            if (content) break;
          }
        } else if (realValue.length > 0) {
          for (let i = 0; i < options.length; i++) {
            let item = options[i];
            for (let j = 0; j < item[childrenField].length; j++) {
              let dItem = item[childrenField][j];
              if (realValue.includes(dItem[valueField])) {
                if (!content) content = [];
                content.push(
                  <van-button size="mini" class="btn" type={fieldButtonType}>
                    {dItem[labelField]}
                  </van-button>
                );
              }
            }
            if (content && content.length == realValue.length) break;
          }
          content = <div class="van-field__control">{content}</div>;
        }
      }

      return content ? content : <div class="van-field__control" />;
    },
    /**
     * @description: 弹窗 渲染
     * @param {*}
     * @return {*}
     */
    popupMultipleRender() {
      let { required } = this;
      let option = {
        props: {
          value: this.realValue,
          options: this.options,
          visible: this.visible,
          multiple: this.multiple,
          search: this.search,
          searchFilter: this.searchFilter,
          searchPlaceholder: this.searchPlaceholder,
          valueField: this.valueField,
          labelField: this.labelField,
          childrenField: this.childrenField,
          disabledField: this.disabledField,
          isConfirm: this.isConfirm,
          isClear: !required,
          confirmButtonText: this.confirmButtonText,
          cancelButtonText: this.cancelButtonText,
          max: this.max,
          height: this.height,
          closeOnClickOverlay: this.closeOnClickOverlay
        },
        on: {
          input: val => {
            this.visible = val;
          },
          confirm: this.confirm
        }
      };
      return <popupTreeSelect {...option} />;
    }
  },
  render() {
    return (
      <div>
        {this.fieldRender()}
        <div />
        {this.popupMultipleRender()}
      </div>
    );
  }
};
</script>

<style lang="less" scoped>
/deep/.van-field__right-icon {
  line-height: 24px;
}

.van-field__control {
  display: inline-block;
}

.van-button--mini {
  margin: 0 4px 2px 0;
  line-height: 20px;
  height: 20px;
  vertical-align: top;
}
</style>
